export function DummyComponent() {
  return null;
}

export const dummyComponentNode = <DummyComponent />;
